import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FinancialYear } from 'src/app/Models/accounting-row';
import { FileSaverService } from 'ngx-filesaver';
import { Company } from 'src/app/Models/company';
import * as moment from 'moment';
import { ApiService } from 'src/app/Services/api.service';

@Component({
  selector: 'ledger-company-account-export',
  templateUrl: './ledger-csv-export-company-account.component.html',
  styleUrls: ['./ledger-csv-export-company-account.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LedgerCsvExportCompanyAccountComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() selectedFinancialYear: FinancialYear;
  @Input() company: Company;
  @Input() token: string;

  constructor(private api: ApiService, private fileSaverService: FileSaverService) { }

  ngOnInit(): void {
  }
  LedgerCompanyAccountExport(): void {
    const from = moment(this.selectedFinancialYear.start).format('YYYY-MM-DD');
    const to = moment(this.selectedFinancialYear.end).format('YYYY-MM-DD');
    const fileName: string = `${this.company.name ? this.company.name : 'unknown'}_${from}_${to}.csv`;
    const fileType = this.fileSaverService.genType(fileName);
    this.api.getGeneralLedgerCSV(this.company.id, from, to, this.token).subscribe((data) => {
      this.fileSaverService.save(data, fileName);
    });

  }
}